'use strict';

import React, { Component } from "react";
import { getRouteChangeElement } from "../../includes/Utilities";

export default class RouteResults extends Component {
    render() {
        if (!(this.props.query && this.props.routes.length)) {
            return null;
        }

        return (
            <>
                <span class="h3">Routes</span>
                <div class="ul">
                    {this.props.routes.slice(0, (!this.props.showAll ? 3 : this.props.routes.length)).map(route => {
                        const routeElement = getRouteChangeElement(route.route_id, false);

                        return (
                            <div class={routeElement ? "li route-alert" : "li"} role="option">
                                <svg role="img" aria-label="Bus"><use xlinkHref={ctspritepath + '#bus-16'}></use></svg>
                                <div>
                                    <a href="#" onClick={(e) => this.props.onRouteClick(e, 'route', route)}><span>{route.route_short_name}</span> - {route.route_name}</a>
                                    {routeElement}
                                </div>
                            </div>
                        );
                    })}
                    {this.props.routes.length > 3 && (
                        <div role="option" className="li">
                            <a href="#"
                               onClick={(e) => this.props.onShowAllClick(e, 'routesShowAll')}>Show {this.props.showAll ? 'less' : 'all'}</a>
                        </div>
                    )}
                </div>
            </>
        );
    }
}
